import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { IEntityResolver, Key } from '@kpd/framework-ngx';
import { License } from 'app/shared/models/license';
import { LicenseService } from 'app/shared/services/license.service';

@Injectable()
export class LicenseEntityResolver implements IEntityResolver<License> {
  constructor(private licenseService: LicenseService) {}

  resolve(params: { id: string }): Observable<License> {
    if (params.id === '0') {
      return of(new License());
    }
    return this.licenseService.getById(Key.composeKeyByRouteParams(params) as Key<string>);
  }
}
